import React, { useState } from 'react';
import { useTasks } from './hooks';

import List from './list';
import ActionButton from 'modules/tasks/action-button';
import TaskCreation from 'modules/tasks/task-creation';
import ListLoader from './listLoader';

const Lists = ({ className }) => {
  const { tasksNotAttended, tasksAttended, loading, loadingMore } = useTasks();
  const [showCreateTask, setShowCreateTask] = useState(false);
  const showLoader = loading || loadingMore;

  return (
    <>
      <div data-testid="lists" className={className}>
        {!loading && (
          <div>
            <List groupedTasks={tasksNotAttended} title="NOT_ATTENDED" />
            <List groupedTasks={tasksAttended} title="KEEP_AN_EYE" />
          </div>
        )}
        {showLoader && <ListLoader loadingMore={loadingMore} />}
      </div>
      {showCreateTask && <TaskCreation setShowCreateTask={setShowCreateTask} />}
      {!showCreateTask && <ActionButton setShowCreateTask={setShowCreateTask} />}
    </>
  );
};

export default Lists;
